const type = 'SET_TIMELINE_EVENTS_ERROR';

const setTimelineEventsError = (data = {}) => ({
  data,
  type,
});

export default setTimelineEventsError;
